import api from "../../api";
import { getOutletsByMerchantEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  GET_OUTLETS_FAILD,
  GET_OUTLETS_LOADING,
  GET_OUTLETS_SUCCESS,
} from "../types";

export const getOutletsByMerchant = (token: any, id: any) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      error?: any;
    }) => void
  ) => {
    dispatch({ type: GET_OUTLETS_LOADING, loading: true });
    await api
      .get(getOutletsByMerchantEndpoint(id), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch({ type: GET_OUTLETS_LOADING, loading: false });
        dispatch({ type: GET_OUTLETS_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        apiError(GET_OUTLETS_LOADING, GET_OUTLETS_FAILD, err, dispatch);
      });
  };
};



